<!-- VcardDetailBody.vue -->
<template>
	<div>
		<div class="order-body" v-if="vcDetail && vcDetail.vcard" v-bind:class="{'ship': vcDetail.vcard.card_id}">
			<div class="image" v-if="true">
				<img src="../../../assets/image/change-icon/e5_box_white@2x.png">
        <span>{{vcDetail.vcard.name}}</span>
			</div>
      <!---->
			<div class="containers" v-on:click="getProductDetail">
        <img class="photo" src="../../../assets/image/change-icon/default_image_02@2x.png" v-if='vcDetail.vcard.goods_thumb.length<=0'>
				<img class="photo" v-bind:src="vcDetail.vcard.goods_thumb" v-if='vcDetail.vcard.goods_thumb.length > 0' data-src='../../../assets/image/change-icon/default_image_02@2x.png' >
				<div class="right-wrapper">
					<label class="title">{{vcDetail.vcard.name}}</label>
          <label class="property" >点击续费</label>
					<div class="desc-wrapper">
						<label class="price">￥ {{utils.currencyPrice(vcDetail.vcard.shop_price)}}</label>
						<label class="count">x1</label>
					</div>
				</div>
			</div>

			<div class="detail">
        <div  v-if="vcDetail.vcard.card_id" class="iconQrcode" ref="iconQrcode" id="iconQrcode"></div>
				<div class="number">
					<label>订单编号：{{vcDetail.vcard.order_sn}} &nbsp;
						<button class="tag-read" :data-clipboard-text="vcDetail.vcard.order_sn" v-on:click="getCopy()">复制</button>
					</label>
					<p>下单时间：{{vcDetail.vcard.add_date * 1000 | convertTime}}</p>
				</div>
        <div class="pay">
          <p>最新有效期：{{vcDetail.vcard.effective * 1000 | convertDate}} ～ {{vcDetail.vcard.expires * 1000 | convertDate}}</p>
        </div>
        <div class="pay">
          <p>卡串号：{{vcDetail.vcard.card_sn}}</p>
          <p>卡密码：{{vcDetail.vcard.card_password}}</p>
        </div>
        <div class="givetime">
          <p>总体使用限制：{{ this.vcDetail.vcard.max_usage>0?this.vcDetail.vcard.max_usage:'无限制' }}</p>
          <p>单日使用限制：{{ this.vcDetail.vcard.daily_max_usage>0?this.vcDetail.vcard.daily_max_usage:'无限制' }}</p>
          <p>剩余使用次数：{{ this.vcDetail.vcard.balance_usage>=0?this.vcDetail.vcard.balance_usage:'' }}</p>
        </div>
			</div>

			<div class="desc section-header section-footer" v-bind:class="{'ship': vcDetail.vcard.card_id}" v-if="this.vcDetail.purchased && this.vcDetail.purchased.length>0">
        <checkout-desc class="desc-item" v-for="(item, index) in this.vcDetail.purchased" :key="index" :title="getFormatPeriod(item.effective, item.expires)" subtitle="已购">
        </checkout-desc>
				<label class="amount">共购买（次） : <span> {{ getOrderTotalPrice }}</span> </label>
			</div>
		</div>
	</div>
</template>

<script>
//import { ORDERSTATUS } from '../static';
import { Indicator, MessageBox, Popup } from 'mint-ui';
import CheckoutDesc from './CheckoutDesc';
import { ENUM } from '../../../const/enum';
import QRCode from 'qrcodejs2'

import { vcardGet } from '../../../api/vcard';
import { Toast } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations } from 'vuex';
export default {

data() {
    return {
      vcDetail: {},
    };
  },

  props: {
    item: {
      type: Object
    }
  },

  components: {
    CheckoutDesc
  },

  created() {
    let id = this.$route.query.id ? this.$route.query.id : null;
    this.vcInfo(id);
  },

  methods: {
    ...mapMutations({
      changeItem: 'changeItem'
    }),

    // 获取虚拟卡详情数据
    vcInfo(id){
      vcardGet(id).then(res => {
        this.vcDetail = res;
        this.$nextTick(()=>{
          let qrcode = new QRCode('iconQrcode', {
            width: 180,
            height: 180, // 高度
            text: '.v'+this.user.id+'-'+this.vcDetail.ticket, // 二维码内容
          })
        })
      })
      /*this.vcDetail = {
          "vcard": {
            "name": "大台食堂包月卡",
            "goods_desc": "",
            "goods_barcode": "333334",
            "shop_price": "0.20",
            "goods_thumb": "https:\/\/sonymall.bestegou.com\/images\/202202\/thumb_img\/898180_thumb_G_1645881333627.jpg",
            "card_id": 7,
            "goods_id": 898180,
            "card_sn": "PzEjQhBa",
            "card_password": "",
            "add_date": 1636291869,
            "effective": 1654088208,
            "expires": 1656593808,
            "order_sn": "2022052856868",
            "max_usage": 20,
            "daily_max_usage": 10,
            "balance_usage": 20,
            "status": 0
          },
          "purchased": [{
              "card_id": '898180',
              "effective": '1656609658',
              "expires": '1659201658'
            },{
              "card_id": '898180',
              "effective": '1656609658',
              "expires": '1659201658'
            }],
          "ticket": "eyJpZCI6Nywic24iOiJQekVqUWhCYSIsInB3IjoiIiwidWlkIjoxMjM0fQ",
          "error_code": 0,
          "debug_id": "629a1ccef3591"
      };
        this.$nextTick(()=>{
          let qrcode = new QRCode('iconQrcode', {
            width: 180,
            height: 180, // 高度
            text: '.v'+this.user.id+'-'+this.vcDetail.ticket, // 二维码内容
          })
        })*/
    },

    getFormatPeriod: function(start_date, end_date) {
      return this.utils.formatDate(start_date * 1000,'YYYY-MM-DD') + ' ～ ' + this.utils.formatDate(end_date * 1000,'YYYY-MM-DD');
    },
    getFormatPrice(key) {
      let priceStr = '# ' + (this.vcDetail.purchased.length);
      return priceStr;
    },

    // 复制
    getCopy() {
      var clipboard = new Clipboard('.tag-read');
      clipboard.on('success', e => {
        console.log('复制成功');
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
      });
      Toast({
        message: '复制成功',
        iconClass: 'mintui mintui-field-success',
        duration: 2000
      });
    },

    // 去商品详情
    getProductDetail() {
      this.$router.push({ name: 'product', query: { id: this.vcDetail.vcard.goods_id, isExchange: false } });
    },

  },

  computed: {
    ...mapState({
      isOnline: state => state.auth.isOnline,
      user: state => state.auth.user
    }),

    getOrderTotalPrice: function() {
      return this.getFormatPrice('total');
    },

  }
};
</script>
<style lang="scss" scoped>
.order-body {
  overflow: auto;
  height: 100%;
  position: absolute;
  width: 100%;
  margin-top: 44px;
}
.image {
  background-image: url('../../../assets/image/change-icon/g1_bg_order@2x.png');
  background-size: cover;
  height: 70px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  img {
    height: 18px;
    padding: 0px 12px;
  }
  span {
    font-size: 17px;
    color: #fff;
  }
}
.receipt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
  padding: 13px;
  background-color: #fff;
  margin-bottom: 8px;
  label {
    display: flex;
    align-items: center;
  }
  img {
    height: 16px;
    margin: 0px 15px 0px 10px;
  }
  .arrow {
    width: 5px;
    height: 10px;
  }
  span {
    font-size: 14px;
    color: #4e545d;
  }
}
.containers {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #fff;
  border-bottom: 1px solid #e8eaed;
}
.onClick {
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #fff;
  p {
    font-size: 14px;
    color: #4e545d;
  }
}
.photo {
  width: 80px;
  height: 80px;
  margin: 15px 10px 15px 15px;
  border: 1px solid #e8eaed;
  flex-basis: 80px;
  flex-shrink: 0;
}
.right-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0px 15px 0px 0px;
  width: 100%;
  overflow: hidden;
}
.title {
  margin-top: 15px;
  color: #4e545d;
  font-size: 14px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.property {
  font-size: 13px;
  color: #7c7f88;
  padding-top: 10px;
}
.count {
  margin-top: 4px;
  color: #7c7f88;
  font-size: 13px;
  margin-right: 10px;
}
.desc-wrapper {
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 21px;
}
.propertyOrder {
  padding-top: 34px;
}
.price {
  color: $primaryColor;
  font-size: 17px;
  margin-left: 0px;
}
.count {
  color: #7c7f88;
  font-size: 16px;
  margin-right: 10px;
}
.address {
  height: 87px;
  background-color: #fff;
  margin-bottom: 10px;
  div {
    padding: 11px 10px 0px;
  }
  img {
    height: 16px;
  }
  span {
    color: #4e545d;
    font-size: 16px;
    &.mobile {
      padding-left: 21px;
    }
  }
  p {
    margin: 5px 18px 11px 32px;
    font-size: 14px;
    color: #7c7f88;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.contact {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 46px;
  background-color: #fff;
  margin-top: 8px;
  border-bottom: 1px solid $lineColor;
  padding: 0 13px;
  span {
    font-size: 12px;
    color: #4e545d;
    padding-right: 6px;
  }
  img {
    width: 12px;
    height: 13px;
  }
}

.detail {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #7c7f88;
  background-color: #fff;
  margin: 8px 0;
  box-sizing: border-box;
  .iconQrcode {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .number {
    padding: 14px 16px;
    border-bottom: 1px solid $lineColor;
    p {
      padding-top: 6px;
      font-size: 14px;
    }
    button {
      color: #7c7f88;
      height: 20px;
      background-color: #fff;
      border: 1px solid #7c7f88;
      width: 54px;
      height: 20px;
      border-radius: 2px;
      font-size: 14px;
    }
  }
  .pay {
    border-bottom: 1px solid $lineColor;
    padding: 14px 16px;
  }
  .givetime {
    padding: 14px 16px;
    font-size: 14px;
  }
  input {
    background-color: #fff;
    border: 1px solid #7c7f88;
  }
}
.desc {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 12px;
  box-sizing: border-box;
  margin-bottom: 80px;
  .desc-item {
    flex: 1;
    margin-top: 10px;
  }
  .amount {
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    color: #4e545d;
    padding-right: 15px;
    border-top: 1px solid $lineColor;
    margin-top: 12px;
    height: 45px;
    line-height: 45px;
    span {
      font-size: 16px;
      color: $primaryColor;
    }
  }
}
.btn {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  align-items: center;
  border-top: 1px solid #e8eaed;
  button {
    width: 82px;
    height: 36px;
    font-size: 14px;
    margin-right: 7px;
    background-color: #fff;
    border: 1px solid #ccc;
  }
  .buttonbottom {
    color: $primaryColor;
    border: 1px solid $primaryColor;
  }
  .mint-popup {
    width: 100%;
    height: 235px;
  }
  .cancels {
    height: 100%;
    .cancelInfo {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      border-bottom: 1px solid #F0F0F0;
      span {
        color: #000;
        font-size: 14px;
      }
      .cancel {
        padding: 10px 15px;
      }
      .success {
        padding: 10px 15px;
      }
    }
    .reason {
      margin-top: 10px;
      p {
        height: 16px;
        line-height: 16px;
        text-align: center;
        padding: 10px;
        &:hover {
          color: red;
        }
      }
    }
  }
}
.ship {
  margin-bottom: 0px;
}
</style>

<!-- 字体图标样式覆盖 -->
<style>
.mint-toast-icon {
  font-size: 38px;
}
button {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/virtualCard/child/VcardDetailBody.vue